
<nz-modal
	[(nzVisible)]="deleteModal"
	(nzOnCancel)="deleteModal = false"
	(nzOnOk)="onDelete()"
	[nzTitle]="'common_deletion' | translate"
	[nzContent]="'common_delete-one' | translate"
	[nzOkLoading]="deleting"
></nz-modal>
<form nz-form
      class="language-form w-100"
      *ngIf="form"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      [nzAutoTips]="explainErrorsService.autoTips">
    <nz-affix>
        <div class="py-4 border-bottom bg-white">
            <div class="container">
                <div class="row">
                    <div class="col-12 d-flex align-items-center justify-content-between">
            			<!-- Title -->
            			<div>
            				<h1 class="mb-0">
            					<span *ngIf="language.isNew()">{{ 'language_create-form-title' | translate }}</span>
            					<span *ngIf="!language.isNew()">{{ language.getLabel() }}</span>
            				</h1>
            				<small *ngIf="!language.isNew()" class="text-black-50">{{ 'common_id' | translate: { id : language.getId() } }}</small>
            			</div>
            			<!-- /Title -->
            			
            			<!-- Actions -->
            			<div>
            				<button
            					nz-button
            					[disabled]="form.invalid"
            					[nzLoading]="saving"
            					nzType="primary"
                                *appRestrictedByScope="{
                                    model: 'language',
                                    action: 'update'
                                }"
            				>
            					{{ 'common_save' | translate }}
            				</button>
                            <ng-container *appRestrictedByScope="{
                                model: 'language',
                                action: 'delete'
                            }">
                                <button
                                    *ngIf="!language.isNew() && deletable"
                                    class="ml-4"
                                    nz-button
                                    nzShape="circle"
                                    [title]="'common_delete' | translate"
                                    [nzLoading]="deleting"
                                    (click)="deleteModal = true"
                                    type="button"
                                >
                                    <i nz-icon nzType="delete"></i>
                                </button>
                            </ng-container>
            			</div>
            			<!-- /Actions -->
            		</div>
            	</div>
            </div>
        </div>
    </nz-affix>
    <div class="container">
    <nz-card class="round-border my-5">
    <div *ngIf="loading" class="row">
        <div class="col-12">
            <nz-skeleton class="no-header" [nzActive]="true"></nz-skeleton>
        </div>
    </div>
    <div *ngIf="!loading">
        <div class="row" *ngIf="!readOnly">
            <div class="col-12 col-md-6">
                <!-- Name -->

                
                <nz-form-item>
                    <h4>{{ 'language_name' | translate }}</h4>
                    <nz-form-control>

             
                        <input nz-input
                               class="w-100"
                               type="text"
                               [placeholder]="'common_value-string' | translate"
                               formControlName="name">
                    </nz-form-control>
                </nz-form-item>
                <!-- /Name -->
            </div>
            <div class="col-12 col-md-6">
                <!-- Display Name -->

                
                <nz-form-item>
                    <h4>{{ 'language_display-name' | translate }}</h4>
                    <nz-form-control>

             
                        <input nz-input
                               class="w-100"
                               type="text"
                               [placeholder]="'common_value-string' | translate"
                               formControlName="display_name">
                    </nz-form-control>
                </nz-form-item>
                <!-- /Display Name -->
            </div>
            <div class="col-12 col-md-6">
                <!-- Language Manager Name -->

                
                <nz-form-item>
                    <h4>{{ 'language_language-manager-name' | translate }}</h4>
                    <nz-form-control>

             
                        <input nz-input
                               class="w-100"
                               type="text"
                               [placeholder]="'common_value-string' | translate"
                               formControlName="language_manager_name">
                    </nz-form-control>
                </nz-form-item>
                <!-- /Language Manager Name -->
            </div>
        </div>

        <nz-divider *ngIf="!language.isNew() && !readOnly"></nz-divider>
        <div *ngIf="!language.isNew()" class="row">
            <div class="col-12 col-md-6" >
                <!-- _Id -->
                <div class="mb-4">
                    <h4>{{ 'language_-id' | translate }}</h4>
                    <div>{{ language.props._id }}</div>
                </div>
                <!-- /_Id -->
            </div>
            <div class="col-12 col-md-6" >
                <!-- Created At -->
                <div class="mb-4">
                    <h4>{{ 'language_created-at' | translate }}</h4>
                    <div>{{ language.props.created_at | date:'medium' }}</div>
                </div>
                <!-- /Created At -->
            </div>
            <div class="col-12 col-md-6" *ngIf="readOnly">
                <!-- Name -->
                <div class="mb-4">
                    <h4>{{ 'language_name' | translate }}</h4>
                    <div>{{ language.props.name }}</div>
                </div>
                <!-- /Name -->
            </div>
            <div class="col-12 col-md-6" *ngIf="readOnly">
                <!-- Display Name -->
                <div class="mb-4">
                    <h4>{{ 'language_display-name' | translate }}</h4>
                    <div>{{ language.props.display_name }}</div>
                </div>
                <!-- /Display Name -->
            </div>
            <div class="col-12 col-md-6" *ngIf="readOnly">
                <!-- Language Manager Name -->
                <div class="mb-4">
                    <h4>{{ 'language_language-manager-name' | translate }}</h4>
                    <div>{{ language.props.language_manager_name }}</div>
                </div>
                <!-- /Language Manager Name -->
            </div>
        </div>
    </div>
    </nz-card>
    </div>
</form>
